import { atom } from "nanostores"

export const $inspectTime = atom<number | undefined>()
